import type { ValidationLabels } from "../../utils/validationMessages";
import { flattenSnapshot, inputRowLabel, scalarText, type SnapshotRow } from "./reportFormat";

// A stored snapshot as a key / value table, every leaf one row in the stored order and every
// value exactly as stored (a decimal string unchanged, its unit from the form label or the
// field's name). Used for the inputs, the references, and a result the current contract
// cannot lay out; never for a value this page computed.

type ReportSnapshotTableProps = {
  snapshot: unknown;
  /** The form's label map; without one the humanized path names the row. */
  labels?: ValidationLabels;
  caption: string;
};

const NO_LABELS: ValidationLabels = { fields: {} };

function rowKey(row: SnapshotRow): string {
  return row.path.map(String).join(".");
}

function valueText(row: SnapshotRow, unit: string | null): string {
  return Array.isArray(row.value)
    ? row.value.map((item) => scalarText(item, unit)).join(", ")
    : scalarText(row.value, unit);
}

export function ReportSnapshotTable({
  snapshot,
  labels = NO_LABELS,
  caption,
}: ReportSnapshotTableProps) {
  const rows = flattenSnapshot(snapshot);
  return (
    <div data-table-scroll>
      <table>
        <caption>{caption}</caption>
        <tbody>
          {rows.map((row) => {
            const { label, unit } = inputRowLabel(row.path, labels);
            return (
              <tr key={rowKey(row)} data-report-row={rowKey(row)}>
                <th scope="row">{label}</th>
                <td>{valueText(row, unit)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ReportSnapshotTable;
